import ibmApi from "@/api/ibmApi";
import { saveFile } from "@/helpers/files";

const taBlobLink = {
  bind(el, binding, vnode) {
    el.addEventListener("click", function (event) {
      event.stopPropagation();
      event.preventDefault();

      const uuid = vnode.data.attrs.uuid.replaceAll("'", "");

      ibmApi.download(uuid, true).then(saveFile);
    });
  },
};

export default taBlobLink;
